<template lang="pug">
	.plan-container.display-flex
		.logo-section
			.logo(v-if="plan.openPlan || openPlan")
				a(:href="enrollNowUrl(plan)" target="_blank" @click="track('LOGO', plan)")
					img(v-if="plan.alternative_logo_url && showAlternativeLogo" :src="plan.alternative_logo_url")
					img(v-else :src="plan.logo_url")
					img(:src="trackingPixelUrl(plan)" style="width:1px!important;height:1px!important;visibility:hidden!important" v-if="plan.tracking_pixel_urls && plan.tracking_pixel_urls.length > 0")
			.logo(v-else)
				img(:src="plan.logo_url")
			.mobile-only.mt-3(v-if="plan.openPlan || openPlan")
				a.button(:href="enrollNowUrl(plan)" target="_blank" @click="track('BUTTON', plan)")
					| OPEN PLAN
		.plan-section.display-flex.flex-column
			.display-flex.plan-info
				div.flex-auto
					h4.plan-name
						| {{plan.name}}
					ul.plan-details
						li
							| State: {{plan.state_id}}
						li
							| Availability: {{stateResidencyRequirement(plan) ? `${plan.state_id} residents only` : 'Nationwide'}}
						li
							| State Tax Benefit
							icon-info.icon-info(:id="stateRatingId")
							span.benefit-value
								| {{taxDeduction(plan)}}
							b-tooltip(:target="stateRatingId" placement="top" triggers="click blur")
								.tooltip-info
									p
										| This is the maximum amount of annual contributions that can be claimed on a state tax return for a couple that is married filing jointly.
				.call-to-action.hide-on-mobile(v-if="plan.openPlan || openPlan")
					a.button(:href="enrollNowUrl(plan)" target="_blank" @click="track('BUTTON', plan)")
						| OPEN PLAN
</template>

<script>
import IconInfo from './icon-info'
import {track} from '../../track'
import {queryParams} from '../../query_params'
import CapRating from "./cap-rating";
import StarRating from "./star-rating";

export default {
	components: {
		IconInfo,
		CapRating,
		StarRating,
	},

	props: {
		"plan": {
			default: {},
			type: Object,
			required: true
		},
		openPlan: {
			default: true
		},

		stateId: {
			default: "-"
		},

		statePlan:{
			default: null
		},

		showAlternativeLogo: {
			default: false
		}

	},

	data(){
		let stateRatingId = `state-rating-${Math.floor(Math.random()*1000000)}`
		let overallRatingId = `overall-rating-${Math.floor(Math.random()*1000000)}`
		let overallRatingId2 = `overall-rating2-${Math.floor(Math.random()*1000000)}`
		return {
			stateRatingId,
			overallRatingId,
			overallRatingId2,
			params: {},
			sfcUrl: process.env.SFC_URL
		}
	},

	mounted(){
		this.params = queryParams()
	},

	methods:{
		track(from='BUTTON', plan){
			if (plan.has_enroll_now_plus) {
				track("PLAN", `${from}_CLICK_PLUS`, plan.id, plan.state_id, { plan_name: plan.name, selected_state_id: this.stateId })
			} else {
				track("PLAN", `${from}_CLICK`, plan.id, plan.state_id, { plan_name: plan.name, selected_state_id: this.stateId })
			}

			this.$emit('click')
		},

		enrollNowUrl(plan){
			let clickSource = "enroll-now-widget-v2"

			if(plan && plan.id && plan.has_enroll_now_plus){
				for(let enroll_now_plus_url of plan.enroll_now_plus_urls){
					if(enroll_now_plus_url.publisher == this.params.company){
						return enroll_now_plus_url.url
					}
				}
				// Fallback
				return plan.enroll_now_plus_urls[0].url
			}

			if(plan && plan.id && plan.has_enroll_now){
				return plan.enroll_now_url
			}

			return `${process.env.SFC_URL}/529-plans/${plan.state_slug}/${plan.slug}`
		},
		trackingPixelUrl(plan){
			if(plan && plan.id && plan.tracking_pixel_urls && plan.tracking_pixel_urls.length > 0){
				for(let tracking_pixel_url of plan.tracking_pixel_urls){
					if(tracking_pixel_url.publisher == this.params.company){
						return tracking_pixel_url.url
					}
				}
				// Fallback
				return ""
			}
		},
		planDetailsUrl(plan){
			return `${process.env.SFC_URL}/529-plans/${plan.state_slug}/${plan.slug}`
		},
		taxDeduction(plan){
			if(!this.statePlan){
				return "N/A"
			}

			if(!this.statePlan.deduction_info.has_deduction && !this.statePlan.deduction_info.has_credit){
				return "N/A"
			}

			if(this.statePlan.deduction_info.has_parity || this.statePlan.state_id == "MN"){
				if(this.statePlan.deduction_info.has_unlimited_contributions){
					return "Unlimited"
				}else{
					return `$${this.formatPrice(this.statePlan.deduction_info.married.deduction_amount)}/yr`
				}
			}

			if(this.statePlan.id == plan.id || this.statePlan.state_id == plan.state_id){
				if(this.statePlan.deduction_info.has_deduction){
					if(this.statePlan.deduction_info.has_unlimited_contributions){
						return "Unlimited"
					}else{
						return `$${this.formatPrice(this.statePlan.deduction_info.married.deduction_amount)}/yr`
					}
				}

				if(this.statePlan.deduction_info.has_credit){
					return `$${this.formatPrice(this.statePlan.deduction_info.married.credit_amount)}/yr`
				}
			}

			return "N/A"
		},
		formatPrice(value) {
			let val = (value/1).toFixed(0).replace('.', ',')
			return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
		},
		stateResidencyRequirement(plan){
			if(["No", "None", "--", null, undefined].indexOf(plan.state_residency_requirements) != -1 || plan.state_residency_requirements == ""){
				return false
			}
			return true
		}
	}
}
</script>

<style lang="stylus" scoped>
	.mobile-only
		display: none
	.display-flex
		display flex
	.flex-column
		flex-direction column
	.flex-auto
		flex: auto
	.icon-info
		cursor: pointer
		position relative
		top: -1px
		margin-left: 4px
		margin-right: 4px
	.button
		color: #fff
		margin 0
		background: #323a56
		letter-spacing: 0.8px
		font-family: Cabin-semi-bold, sans-serif
		font-weight: 300;
		font-size: 14px;
		line-height: 15px;
		text-align: center;
		text-transform: uppercase;
		padding: 14px 17px
		-webkit-box-shadow none
		box-shadow: none
		border-radius 0px
		border 0px
		cursor: pointer;
		text-decoration: none
		white-space: nowrap
		display inline-block
		vertical-align: middle;
		-webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
		transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
		-o-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
		transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
		transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
		&:hover
		&:active
		&:focus
			text-decoration: none
			background: #2c40d0
	.plan-container
		background: #FFFFFF;
		border: 1px solid #D4D4D4;
		box-sizing: border-box;
		padding 25px
		.logo-section
			margin-right 15px
		.plan-name
			font-family: 'Cabin', sans-serif
			font-weight: 600;
			font-size: 15px;
			line-height: 17px;
			margin-bottom 13px
			margin-right 30px
		.logo
			img
				width: 120px
		.plan-section
			flex: auto
		.plan-details
			// margin 0 0 20px 0
			margin 0
			padding 0
			list-style none
			li
				font-style: normal;
				font-weight: normal;
				letter-spacing: 0.3px;
				font-size: 14px;
				line-height: 18px;
				margin-bottom 2px
		.ratings-section
			p
				font-size: 14px;
				line-height: 18px;
				margin-bottom 0

		@media(max-width: 490px)
			.hide-on-mobile
				display: none
			.mobile-only
				display: block
			.plan-name
				margin-right 0px
			.plan-details
				margin-bottom 0px
				.icon-info
					margin-right 8px !important
				.benefit-value
					margin-left 0px !important


</style>
